export default "__VITE_ASSET__BjkvD6Jn__"